// "M.SS.hh" (Örn: "2.26.22") formatındaki metni saniyeye çevirir
export function parseTimeToSeconds(timeStr) {
  if (!timeStr || timeStr === '—' || timeStr === 'Kayıt Yok' || timeStr === '-') return null;
  const parts = timeStr.split('.');
  if (parts.length < 2) return null;
  const minutes = parseInt(parts[0], 10);
  const seconds = parseInt(parts[1], 10);
  const hundredths = parts[2] ? parseInt(parts[2], 10) : 0;
  return minutes * 60 + seconds + (hundredths / 100);
}

// Saniyeyi "M.SS.hh" formatına geri çevirir
export function formatSecondsToTime(seconds) {
  if (typeof seconds !== 'number' || isNaN(seconds)) return 'Kayıt Yok';
  const mins = Math.floor(seconds / 60);
  const remainingSecs = Math.floor(seconds % 60);
  const hundredths = Math.round((seconds - Math.floor(seconds)) * 100);
  const secStr = remainingSecs.toString().padStart(2, '0');
  const hundStr = hundredths.toString().padStart(2, '0');
  return `${mins}.${secStr}.${hundStr}`;
}

// Jokey ismini dosya adı formatına normalize eder
export function getJockeyFilename(name) {
  if (!name) return 'default_jockey.webp';
  return name
    .replace(/İ/g, 'i')
    .replace(/ı/g, 'i')
    .replace(/I/g, 'i')
    .replace(/Ş/g, 's')
    .replace(/ş/g, 's')
    .replace(/Ç/g, 'c')
    .replace(/ç/g, 'c')
    .replace(/Ğ/g, 'g')
    .replace(/ğ/g, 'g')
    .replace(/Ö/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/Ü/g, 'u')
    .replace(/ü/g, 'u')
    .toLowerCase()
    .replace(/â/g, 'a')
    .replace(/’/g, '_')
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/_$/, '') + '.webp';
}

// Hava durumu kodunu uygun emojiye eşleştirir
export function getWeatherIcon(code) {
  if (code === null || code === undefined) return '☀️';
  if (code === 0) return '☀️';
  if ([1, 2, 3].includes(code)) return '🌤️';
  if ([45, 48].includes(code)) return '🌫️';
  if ([51, 53, 55].includes(code)) return '🌦️';
  if ([61, 63, 65, 80, 81, 82].includes(code)) return '🌧️';
  if ([71, 73, 75].includes(code)) return '❄️';
  if ([95, 96, 99].includes(code)) return '⚡';
  return '☀️';
}
